import * as dayjs from "dayjs";
import * as LocalizedFormat from "dayjs/plugin/localizedFormat";
import * as utc from "dayjs/plugin/utc";
import * as localeData from "dayjs/plugin/localeData";
import * as timezone from "dayjs/plugin/timezone";

import "dayjs/locale/fr";

const locale = document.documentElement.lang;
dayjs.extend(LocalizedFormat).locale(locale);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(timezone);

export default dayjs;
